import React from "react";
const icon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 35.4167C2.70833 35.4167 1.82292 35.0369 1.09375 34.2773C0.364583 33.5178 0 32.5955 0 31.5104V13.2812C0 12.1962 0.364583 11.2739 1.09375 10.5143C1.82292 9.75477 2.70833 9.375 3.75 9.375H46.25C47.2917 9.375 48.1771 9.75477 48.9062 10.5143C49.6354 11.2739 50 12.1962 50 13.2812V31.5104C50 32.5955 49.6354 33.5178 48.9062 34.2773C48.1771 35.0369 47.2917 35.4167 46.25 35.4167H42.25V31.5104H46.25V13.2812H3.75V31.5104H20.25V35.4167H3.75ZM31.25 40.625L29 35.4167L24 33.0729L29 30.7292L31.25 25.5208L33.5 30.7292L38.5 33.0729L33.5 35.4167L31.25 40.625ZM37.5 26.8229L36.1875 23.763L33.25 22.3958L36.1875 21.0286L37.5 17.9687L38.8125 21.0286L41.75 22.3958L38.8125 23.763L37.5 26.8229Z"
      fill="url(#paint0_linear_1459_24)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1459_24"
        x1="6.60879e-08"
        y1="21.7448"
        x2="50.6256"
        y2="22.3448"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A306E4" />
        <stop offset="1" stopColor="#8302E9" />
      </linearGradient>
    </defs>
  </svg>
);

export default icon;
